<!--
 * @Descripttion: 
 * @version: 
 * @Author: A21
 * @Date: 2022-05-26 15:09:20
 * @LastEditors: A21
 * @LastEditTime: 2022-06-01 17:02:44
 * @FilePath: /intell-loan/src/views/pages/otherPage/authorizationAgreement.vue
-->
<template>
  <div class="authorizationAgreement">
    <List class="line" left="企业名称" :right="orderInfo.corpName || ''" />
    <List class="line" left="纳税人识别号" :right="orderInfo.taxNo || ''" />
    <List class="line" left="法人名称" :right="orderInfo.legalName || ''" />
    <List class="line" left="法人身份证号" :right="orderInfo.legalIdentity || ''" />
    <div class="Contract">
      <Contract
        text="本人已阅读并完全同意"
        :list="contractList"
        :argementFlag="argementFlag"
        :changeArgementFlag="changeArgementFlag"
        :defaultCheck="false"
        v-model="isAgree"
      />
    </div>
    <div class="nextStepBox">
      <Button
        :loading="loading"
        loadingText="签署中..."
        type="danger"
        text="确认签署"
        :disabled="!isAgree"
        class="nextStep"
        :click="nextStep"
      />
    </div>
     
  </div>
</template>

<script>
import List from '@/components/List.vue';
import Contract from '@/components/Contract.vue';
import Button from '@/components/Button.vue';
import { Toast } from 'vant';


export default {
  name: 'authorizationAgreement',
  components: {
    List,
    Button,
    Contract,
  },
  data() {
    return {
      isAgree: false,
      argementFlag: false,
      loading: false,
      orderInfo: {},
      contractList: [
        {
          text: '个人信息查询和提供在线授权书',
          value: 'AuthorizationContract',
        },
      ],
    };
  },
  beforeCreate() {
    // 浦发流程合规修改，去掉征信授权书签署、征信授权书签署成功两页面，所以后端不动，前端自动重定向
    this.$router.push(`/supermarket/v2/complianceLipChaeck?orderId=${this.$route.query.orderId}&productId=${this.$route.query.productId}`);
  },
  mounted() {
    const { returnMessage } = this.$route.query;
    if (returnMessage) {
      Toast({
        message: returnMessage,
        duration: 3000,
      });
      setTimeout(() => {
        this.getOrderInfo();
      }, 3000);
    } else {
      this.getOrderInfo();
    }
  },
  methods: {
    // 获取用户信息
    getOrderInfo() {
      const {
        getInformation,
      } = this.$api.CommonForms;
      const { orderId } = this.$route.query;
      getInformation(orderId).then((res) => {
        if (res && res.success) {
          this.orderInfo = res.data;
        } else {
          Toast(res.returnMessage);
        }
      });
    },
    nextStep() {
      this.$router.push(`/supermarket/v2/complianceLipChaeck?orderId=${this.$route.query.orderId}&productId=${this.$route.query.productId}`);
      this.loading = true;
    },
    changeArgementFlag(flag = false) {
      this.argementFlag = flag;
    },
  },
};
</script>
<style lang="scss" scoped>
.line{
  border-bottom: 1px solid #eee;
}
.Contract{
  margin: 30px 0;
}
.nextStepBox{
  width: 100%;
  position: fixed;
  bottom: 70px;
}
>>> .infoListRight{
  width: 200px;
  text-align: end;
}
</style>
